import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementCheckboxes', 'WebformElementRadios'],
  (item) => {
    if (item.element.__typename === 'WebformElementCheckboxes') {
      return {
        $formkit: 'checkbox',
        options: item.element.options,
      }
    }
    return {
      $formkit: 'radio',
      options: item.element.options,
    }
  },
)
